export const isAuto = (value) => value === 'auto'
